<template>
    <div class="page page-standby">
        <div class="container" v-if="settings.enabled_card_reader === false">
            <div class="row">
                <div class="col-md-12 form-group">
                    <label for="card-uuid"> Identificador Único Universal do Cartão</label>
                    <input type="text" class="form-control" id="card-uuid" name="card-uuid" v-model="form.card_uuid">
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 form-group">
                    <button class="bnt btn-primary float-right" type="button" @click="onCardRead(form.card_uuid)">
                        Entrar
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="standby-logo col-md-6 offset-3">
                    <img src="./../../assets/images/logo_full.png" alt="">
                </div>
            </div>
            <div class="row">
                <div class="standby-kids col-md-6 offset-3">
                    <img src="./../../assets/images/kids.png" alt="Imagens de crianças felizes">

                </div>
            </div>
        </div>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-8 offset-2">
                    <transition name="bounce">
                        <h1 v-if="canShowMessage" class="text-center" v-html="message"></h1>
                    </transition>
                </div>
            </div>
        </div>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-8 offset-2">
                    <transition name="bounce">
                        <button v-if="hasCardError" onclick="window.location.reload();"
                                class="btn btn-lg btn-block btn-danger">Tente Novamente
                        </button>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import signalRFactory, {CARD_ERROR_READ, CARD_READ} from '../../signal-r-factory.js';
    import {mapActions, mapGetters} from 'vuex';
    import getSettings from '../../support/get-settings';

    export default {
        name: 'Standby',

        data() {
            return {
                lockRead: false,
                hasCardError: false,
                signalR: null,
                settings: null,
                form: {
                    card_uuid: '',
                },
                messages: {
                    configError: 'Houve um problema na configuração do totem 😭!',
                    errorConnectedWithHalService: 'Não foi possível conectar ao leitor e impressora.',
                    standBy: 'Aproxime seu cartão ou pulseira',
                    cardRead: '⏳ Aguarde ...',
                    success: `Bem Vindo {dependentName} 😀`,
                    errorRead: `Ops não foi possível ler o cartão 😅. <br> Tente novamente `,
                },
                message: '',
                canShowMessage: true,
            };
        },

        beforeMount() {

            if (getSettings() === null) {
                this.$router.push({name: 'config'});
            }

            this.settings = getSettings();
            this.message = this.messages.standBy;
        },
        async mounted() {
            this.cancelOrder();
            this.signalR = await signalRFactory();

            if (!getSettings().token) {
                await this.changeMessage(this.messages.configError);
                this.hasCardError = true;
                return;
            }

            if (!getSettings().url) {
                await this.changeMessage(this.messages.configError);
                this.hasCardError = true;
                return;
            }

            await this.registerListeners();

        },
        computed: {
            ...mapGetters(
                {getAccount: 'getAccount'},
            ),
        },
        async beforeDestroy() {
            if(this.signalR){
                this.signalR.off(CARD_READ);
                this.signalR.off(CARD_ERROR_READ);
            }
        },

        methods: {
            ...mapActions({cardRead: 'cardRead', cancelOrder: 'cancelOrder'}),
            async registerListeners() {
                if (this.signalR === undefined) {
                    await this.changeMessage(this.messages.errorConnectedWithHalService);
                    this.hasCardError = true;
                    return;
                }

                this.signalR.on(CARD_READ, await this.onCardRead);
                this.signalR.on(CARD_ERROR_READ, await this.onCardError);
            },
            async onCardError() {
                if (this.lockRead) {
                    return;
                }
                await this.changeMessage(this.messages.errorRead);
                await sleep(3000);
                await this.changeMessage(this.messages.standBy);
                this.lockRead = false;
            },
            async onCardRead(uuid) {

                if (this.lockRead) {
                    return;
                }
                this.lockRead = true;

                await this.changeMessage(this.messages.cardRead);

                try {
                    await this.cardRead(uuid);

                    await this.changeMessage(this.makeMessageSuccess());
                    await sleep(1000);

                    await this.$router.push({name: 'products'});
                } catch (e) {
                    await this.handleErrorOfCardRead(e);
                }
            },
            async handleErrorOfCardRead(error) {
                if (error.response && error.response.status === 404) {
                    await this.changeMessage('Ops, não conseguimos encontrar este cartão 😅');
                    await sleep(2000);
                    await this.changeMessage(this.messages.standBy);
                } else {
                    this.hasCardError = true;
                    await this.changeMessage(error.message);
                }
                this.lockRead = false;
            },
            async changeMessage(message) {
                this.canShowMessage = false;
                await sleep(500);

                this.message = message;
                this.canShowMessage = true;
            },
            makeMessageSuccess() {
                return this.messages.success.replace(
                    '{dependentName}',
                    this.getAccount.dependent.name,
                );
            },
        },

    };

</script>


<style scoped>

    .page {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
    }

    .page-standby {
        background-color: var(--light-orange);
    }

    .standby-logo {
        margin-top: 200px;
    }

    .standby-logo img {
        width: 100%;
    }

    .standby-kids img {
        width: 100%;
    }

    h1 {
        color: #fff;
        font-size: 60px;
    }

</style>

